// @flow
import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import type {RideStatusType} from "../../../Utils/AppUtils";
import {RideStatus} from "../../../Utils/AppUtils";
import RideBoarded from "./RideBoarded/RideBoarded";
import RideAccepted from "./RideAccepted/RideAccepted";
import AppSelectors from "../../../Store/Ducks/App/selectors";
import CurrentProposalSelectors from "../../../Store/Ducks/CurrentProposal/selectors";
import Screens from "../../../Store/Views/screens";
import CurrentRideSelectors from "../../../Store/Ducks/CurrentRide/selectors";
import TokenDataSelectors from "../../../Store/Ducks/TokenData/selectors";
import BackendOperations from "../../../Store/Middleware/Backend/operations";
import ThankYou from "../ThankYou/ThankYou";

const PROPOSAL_STATUS_INVERVAL_MILLI = 5000;
const RIDE_STATUS_INTERVAL = 5000;

type ConnectedProps = {
    awaitingDriverApproval: boolean,
    onLastRideStatus: () => mixed,
    onProposalStatus: () => mixed,
    rideStatus: RideStatusType,
    isInIframe: boolean
};

class Ride extends PureComponent<ConnectedProps> {

    proposalStatusInverval: any; //IntervalID is not recognized for some reason
    rideStatusInverval: any; //IntervalID is not recognized for some reason
    invokeProposalStatus: () => void;
    invokeRideStatus: () => void;
    onRideAccepted: () => void;

    constructor(props) {
        super(props);
        this.proposalStatusInverval = undefined;
        this.rideStatusInverval = undefined;
        this.invokeProposalStatus = this.invokeProposalStatus.bind(this);
        this.invokeRideStatus = this.invokeRideStatus.bind(this);
    }

    invokeProposalStatus() {
        if (this.props.awaitingDriverApproval) {
            this.props.onProposalStatus();
        } else {
            clearInterval(this.proposalStatusInverval);
            this.rideStatusInverval = setInterval(this.invokeRideStatus, RIDE_STATUS_INTERVAL);
            this.invokeRideStatus();
        }
    }

    invokeRideStatus() {
        this.props.onLastRideStatus();
    }

    onRideAccepted() {
        if (this.props.isInIframe) {
            const documentReferrerOrigin = document.referrer.match(/^.+:\/\/[^\/]+/)[0];
            const parentHostname = documentReferrerOrigin.match(/^.+:\/\/([^:]+)/)[1];
            if (parentHostname.endsWith('ridewithvia.com')) {
                window.parent.postMessage('webapp_navigation_to_ridescreen', documentReferrerOrigin)
            }
        }
    }

    componentDidMount() {
        if (this.props.rideStatus === RideStatus.ACCEPTED) {
            this.onRideAccepted();
        }
        if (this.props.awaitingDriverApproval) {
            this.proposalStatusInverval = setInterval(this.invokeProposalStatus, PROPOSAL_STATUS_INVERVAL_MILLI);
            this.invokeProposalStatus();
        } else {
            this.rideStatusInverval = setInterval(this.invokeRideStatus, RIDE_STATUS_INTERVAL);
            this.invokeRideStatus();
        }

    }

    componentWillUnmount() {
        this.proposalStatusInverval && clearInterval(this.proposalStatusInverval);
        this.rideStatusInverval && clearInterval(this.rideStatusInverval);
    }

    render() {
        if (this.props.rideStatus === RideStatus.ACCEPTED) {
            return (<RideAccepted/>);
        }
        if (this.props.rideStatus === RideStatus.BOARDED) {
            return (<RideBoarded/>);
        }
        if (this.props.rideStatus === RideStatus.FINISHED) {
            return (<ThankYou offerAppDownload={!this.props.isWav}/>);
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        if (this.props.rideStatus === RideStatus.ACCEPTED && prevProps.rideStatus !== RideStatus.ACCEPTED) {
          this.onRideAccepted();
        }
    }
}

const mapStateToProps = (state, props) => {
    return {
        pickup: CurrentProposalSelectors.getProposalPickup(state),
        dropoff: CurrentProposalSelectors.getProposalDropoff(state),
        awaitingDriverApproval: Screens.shouldShowAwaitingDriverApproval(state),
        rideStatus: CurrentRideSelectors.getRideStatus(state),
        isWav: TokenDataSelectors.tokenDataSelector(state).is_wav,
        isInIframe: AppSelectors.appSelector(state).isInIframe,
    };
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            onLastRideStatus: BackendOperations.doLastRideStatus,
            onProposalStatus: BackendOperations.doProposalStatus,
        },
        dispatch);
};
export default connect(mapStateToProps, mapActionsToProps)(Ride);



// WEBPACK FOOTER //
// ./src/Components/Screen/Ride/Ride.js